<template>
  <RightSideBar @close="$emit('close')" button-class="bg-dynamicBackBtn text-white" :close-button="true"">
    <template v-slot:title>
      <p class="text-darkPurple flex gap-5 items-center cursor-pointer">
        View Relief
      </p>
    </template>
    <p class="my-6 text-jet text-base">
      Enter details of your eligible relief (e.g., rent, life assurance, or annuity)
      and upload supporting evidence for validation.
    </p>
    <div class="w-full flex flex-col gap-1 text-jet text-sm">
      <c-text
        :value="relief.name"
        placeholder=""
        variant="w-full h-10"
        class="mt-2"
        label="Relief type"
        :disabled="true"
      />
    </div>

    <div v-if="relief.reliefType === 'rent'" class="my-6 text-jet text-sm">
      <c-text label="How much is your annual rent?" :disabled="true"
        placeholder="" type="number" :value="relief.amount" variant="w-full h-10"
        class="mt-2"
      />
      <div class="flex justify-between items-center gap-2 mt-6">
        <div class="w-1/2">
          <label class="date-label">Start Date </label>
          <div class="date-flex bg-disabled">
            <datepicker
              placeholder=""
              style="width: 100%; outline: none"
              input-class="date-input"
              format="MMMM d, yyyy"
              v-model="relief.startDate"
              :disabled="true"
            />
          </div>
        </div>
        <div class="w-1/2">
          <label class="date-label"> End Date </label>
          <div class="date-flex bg-disabled">
            <datepicker
              placeholder=""
              style="width: 100%; outline: none"
              input-class="date-input"
              format="MMMM d, yyyy"
              v-model="relief.endDate"
              :disabled="true"
            />
          </div>
        </div>
      </div>
      <div class="line"></div>
      <p>Upload evidence (E.g Rent receipt or lease agreement)</p>
    </div>

    <div v-if="relief.reliefType === 'lifeAssurance'" class="my-6 text-jet text-sm">
      <c-text label="How much is your annual premium?" :disabled="true"
        placeholder="" type="number" :value="relief.amount" variant="w-full h-10"
        class="mt-2"
      />
      <div class="line"></div>
      <p>Upload evidence (E.g Life assurance contract)</p>
    </div>

    <div v-if="relief.reliefType === 'deferredAnnuity'" class="my-6 text-jet text-sm">
      <c-text label="How much is your annual premium?" :disabled="true"
        placeholder="" type="number" :value="relief.amount" variant="w-full h-10"
        class="mt-2"
      />
      <div class="line"></div>
      <p>Upload evidence (E.g Deferred annuity contract)</p>
    </div>

    <div
      class="w-full h-10 bg-color pl-3 mt-6 flex justify-center items-center"
    >
      <div class="w-full">
        <div
          class="w-full flex justify-between items-center gap-6"
        >
          <div class="w-auto h-full flex justify-start items-center gap-1">
            <div>
              <icon icon-name="pdf" size="xs" class="icon" v-if="relief.fileMimeType === 'pdf'"/>
              <icon icon-name="doc" size="xs" class="icon" v-else-if="relief.fileMimeType === 'doc'"/>
              <icon icon-name="xlsx" size="xs" class="icon" v-else-if="relief.fileMimeType === 'xlsx'"/>
              <icon icon-name="csv" size="xs" class="icon" v-else-if="relief.fileMimeType === 'csv'"/>
              <icon icon-name="ppt" size="xs" class="icon" v-else-if="relief.fileMimeType === 'ppt'"/>
              <icon icon-name="png" size="xs" class="icon" v-else-if="relief.fileMimeType === 'png'"/>
              <icon icon-name="jpg" size="xs" class="icon" v-else-if="relief.fileMimeType === 'jpg'"/>
              <icon icon-name="jpg" size="xs" class="icon" v-else-if="relief.fileMimeType === 'jpeg'"/>
            </div>

            <div class="flex justify-center items-start gap-2">
              <p class="text-blackJet text-sm">
                {{ relief.fileName && relief.fileName }}.{{ relief.fileMimeType && relief.fileMimeType}}
              </p>
              <p class="text-xs text-romanSilver mt-1">
                  • {{ relief.fileSize ? kbToSize(relief.fileSize) : ''}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </RightSideBar>
</template>

<script>
  import RightSideBar from "@/components/RightSideBar";
  import CText from "@scelloo/cloudenly-ui/src/components/text";
  import Datepicker from "vuejs-datepicker";

  export default {
    name: "AddReliefs",
    components: {
      RightSideBar,
      CText,
      Datepicker
    },
    props: {
      relief: {
        type: Object,
        default: () => ({})
      },
    },
    data() {
      return {
        rele: ''
      };
    },
    methods: {
      kbToSize(kb) {
        const value = Number(kb);

        const sizes = ['KB', 'MB', 'GB', 'TB', 'PB'];

        if (!value) return '0 KB';

        if (value < 1) return `${(value * 1024).toFixed(1)} KB`;

        const i = Math.floor(Math.log(value) / Math.log(1024));
        const sizeIndex = Math.min(i, sizes.length - 1);

        if (sizeIndex === 0) return `${value.toFixed(1)} KB`;

        return `${(value / (1024 ** sizeIndex)).toFixed(1)} ${sizes[sizeIndex]}`;
      }
    }
  };
</script>

<style scoped>
.line{
  border: 0.5px solid #00000029;
  width: 100%;
  height: 0;
  margin: 24px auto;
  border-radius: 10px;
  padding: 0;
}
.bg-color{
  background: #FBFBFB;
}
.bg-disabled{
   background: #E0E0E0 !important;
}
</style>